import Check from 'sd-ui/dist/commonjs/components/Icon/Check';
import CheckClipboard from 'sd-ui/dist/commonjs/components/Icon/CheckClipboard';
import CitedBy66 from 'sd-ui/dist/commonjs/components/Icon/CitedBy66';
import Connection from 'sd-ui/dist/commonjs/components/Icon/Connection';
import Cross from 'sd-ui/dist/commonjs/components/Icon/Cross';
import Download from 'sd-ui/dist/commonjs/components/Icon/Download';
import Expand from 'sd-ui/dist/commonjs/components/Icon/Expand';
import Help from 'sd-ui/dist/commonjs/components/Icon/Help';
import Info from 'sd-ui/dist/commonjs/components/Icon/Info';
import List from 'sd-ui/dist/commonjs/components/Icon/List';
import LogOut from 'sd-ui/dist/commonjs/components/Icon/LogOut';
import Minus from 'sd-ui/dist/commonjs/components/Icon/Minus';
import NavigateDown from 'sd-ui/dist/commonjs/components/Icon/NavigateDown';
import NavigateLeft from 'sd-ui/dist/commonjs/components/Icon/NavigateLeft';
import NavigateRight from 'sd-ui/dist/commonjs/components/Icon/NavigateRight';
import NavigateUp from 'sd-ui/dist/commonjs/components/Icon/NavigateUp';
import Pdf from 'sd-ui/dist/commonjs/components/Icon/Pdf';
import Plus from 'sd-ui/dist/commonjs/components/Icon/Plus';
import Printer from 'sd-ui/dist/commonjs/components/Icon/Printer2';
import Refresh from 'sd-ui/dist/commonjs/components/Icon/Refresh';
import Rewind from 'sd-ui/dist/commonjs/components/Icon/Rewind';
import Search from 'sd-ui/dist/commonjs/components/Icon/Search';
import Share from 'sd-ui/dist/commonjs/components/Icon/Share';
import Spinner from 'sd-ui/dist/commonjs/components/Icon/Spinner';

export default {
  Check,
  CheckClipboard,
  CitedBy66,
  Connection,
  Cross,
  Download,
  Expand,
  Help,
  Info,
  List,
  LogOut,
  Minus,
  NavigateDown,
  NavigateLeft,
  NavigateRight,
  NavigateUp,
  Pdf,
  Plus,
  Printer,
  Refresh,
  Rewind,
  Search,
  Share,
  Spinner,
};
